import { pick } from 'lodash'

const transformToUpdateIngredientNotesArgs = data => pick(data, ['notes'])

export default transformToUpdateIngredientNotesArgs
